import { useTranslation } from "react-i18next";

export const NotFoundLink = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-grow flex-col items-center justify-center px-4 py-20">
      <div className="mx-auto max-w-xl rounded-xl bg-white p-10 text-center shadow-[0_12px_16px_rgba(0,0,0,0.03)]">
        <h1 className="mb-4 font-serif text-2xl lg:text-3xl">
          {t("VOUCHERS_DISTRIBUTION.ORDER_CONFIRMATION.NOT_FOUND.TITLE")}
        </h1>
        <p className="mb-8 text-gray-600">{t("VOUCHERS_DISTRIBUTION.ORDER_CONFIRMATION.NOT_FOUND.DESCRIPTION")}</p>
        <a
          href={window.location.origin}
          className="inline-block rounded-full bg-primary px-8 py-3 font-semibold text-white transition-colors hover:bg-primary/90"
        >
          {t("VOUCHERS_DISTRIBUTION.ORDER_CONFIRMATION.NOT_FOUND.CTA")}
        </a>
      </div>
    </div>
  );
};
